import Vue from 'vue'
import KeySelect from "@/components/Select/KeySelect.vue";


Vue.component('KeySelect',KeySelect);